import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Upload, FileText, FolderOpen } from "lucide-react";

export default function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  const isAllUploadsActive = isActive("/public-uploads") && !location.pathname.includes("by-category") && !location.pathname.includes("upload/");
  const isCategoryActive = isActive("by-category");
  const isUploadActive = isActive("upload/new");

  return (
    <div className="border-b">
      <nav className="flex space-x-2 pb-2">
        <Button
          variant={isAllUploadsActive ? "default" : "ghost"}
          onClick={() => navigate("/app/public-uploads")}
          className="gap-2"
        >
          <FileText className="h-4 w-4" />
          All Uploads
        </Button>
        <Button
          variant={isCategoryActive ? "default" : "ghost"}
          onClick={() => navigate("/app/public-uploads/by-category")}
          className="gap-2"
        >
          <FolderOpen className="h-4 w-4" />
          By Category
        </Button>
        <Button
          variant={isUploadActive ? "default" : "ghost"}
          onClick={() => navigate("/app/public-uploads/upload/new")}
          className="gap-2"
        >
          <Upload className="h-4 w-4" />
          Upload File
        </Button>
      </nav>
    </div>
  );
}
